<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appssid'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'点名'">
              <a-input
                :placeholder="$t('enter') + ' 点名'"
                v-model='queryParam.pointName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'app版本'">
              <a-input
                :placeholder="$t('enter') + ' app版本'"
                v-model='queryParam.versionName'></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='12' :sm='12'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery(0)' icon='search'>查询</a-button>
              <a-button type='primary' @click='downLoadData()' icon='download' style='margin-left: 8px'>导出</a-button>
              <a-button type='primary' @click='searchReset(0)' icon='reset' style='margin-left: 8px'>重置</a-button>

            </span>
          </a-col>
        </a-row>
        <a-row :gutter='24' style='margin-bottom: 20px'>
          <a-col :md='20' :sm='20'>
            <a-button type='primary' @click='VisualChart(1)' icon='download'
            >查看可视化图表
            </a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookTodays(1)'>查看当天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookThreedays(1)'>查看近3天数据</a-button>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        bordered
        @change='handleTableChange'>
        <template slot='pointNameValue' slot-scope='text, record,index'>
          <span v-if="record.pointName === 'SYSTEM_APP_OPEN'">{{ text }}     (启动APP-首次打开)</span>
          <span v-else-if="record.pointName === 'CLICK_FIRST_INDEX_APPLY_SUBMIT'">{{ text
            }}     (点击申请按钮（首）)</span>
          <span v-else-if="record.pointName === 'CLICK_INDEX_APPLY_SUBMIT'">{{ text }}     (点击申请按钮（复）)</span>
          <span v-else-if="record.pointName === 'CLICK_LOGIN_CODE_SUCCESS'">{{ text }}     (点击获取验证码)</span>
          <span v-else-if="record.pointName === 'CLICK_LOGIN_SUBMIT'">{{ text }}     (点击登录｜注册按钮)</span>
          <span v-else-if="record.pointName === 'SYSTEM_REGISTER_SUCCESS'">{{ text }}     (注册成功)</span>
          <span v-else-if="record.pointName === 'SYSTEM_LOGIN_SUCCESS'">{{ text }}     (登录成功)</span>
          <span v-else-if="record.pointName === 'CLICK_CONTACT_INF_SUBMIT'">{{ text }}     (联系人信息提交按钮)</span>
          <span v-else-if="record.pointName === 'CLICK_BANK_INF_SUBMIT'">{{ text }}     (点击银行卡信息提交按钮)</span>
          <span v-else-if="record.pointName === 'CLICK_ID_PICTURE_F_SUBMIT'">{{ text }}     (点击身份证-正面拍照)</span>
          <span v-else-if="record.pointName === 'CLICK_ID_PICTURE_B_SUBMIT'">{{ text }}     (点击身份证-反面拍照)</span>
          <span v-else-if="record.pointName === 'SYSTEM_ID_PICTURE_SUCCESS'">{{ text }}     (身份证上传成功)</span>
          <span v-else-if="record.pointName === 'SYSTEM_FACE_SUCCESS'">{{ text }}     (人脸上传成功)</span>
          <span v-else-if="record.pointName === 'CLICK_ID_INF_SUBMIT'">{{ text }}     (点击身份信息提交按钮)</span>
          <span v-else-if="record.pointName === 'CLICK_BASIC_INF_SUBMIT'">{{ text }}     (点击基本信息提交按钮)</span>
          <span v-else-if="record.pointName === 'CLICK_WORK_INF_SUBMIT'">{{ text }}     (点击工作信息提交按钮)</span>

          <span v-else-if="record.pointName === 'CLICK_FIRST_AMOUNT_SUBMIT'">{{ text }}     (选择金额期限-首贷)</span>
          <span v-else-if="record.pointName === 'CLICK_AMOUNT_SUBMIT'">{{ text }}     (选择金额期限-复贷)</span>
          <span v-else-if="record.pointName === 'CLICK_FIRST_CONFITM_SUBMIT'">{{ text }}     (确认借款-首贷)</span>
          <span v-else-if="record.pointName === 'CLICK_CONFITM_SUBMIT'">{{ text }}     (确认借款-复贷)</span>
          <span v-else-if="record.pointName === 'CLICK_LOAN_SUBMIT'">{{ text
            }}     (点击申请成功确认按钮（OK按钮）)</span>
          <span v-else-if="record.pointName === 'SYSTEM_LOAN_SUCCESS'">{{ text }}     (申请提交成功)</span>


          <span v-else-if="record.pointName === 'SERVICE_RISK_FIRST_SUCCESS'">{{ text }}     (新户-风控审核通过)</span>
          <span v-else-if="record.pointName === 'SERVICE_RISK_LAST _SUCCESS'">{{ text }}     (老户-风控审核通过)</span>
          <span v-else-if="record.pointName === 'SERVICE_LOAN_FINISH'">{{ text }}     (放款成功-待还款状态)</span>

          <span v-else-if="record.pointName === 'SYSTEM_FIRST_LOAN_REJECT'">{{ text
            }}     (首贷-最终审核拒绝-1天后)</span>
          <span v-else-if="record.pointName === 'SYSTEM_LAST_LOAN_REJECT'">{{ text
            }}     (复贷-最终审核拒绝-1天后)</span>


          <span v-else-if="record.pointName === 'CLICK_UP_BANK_INF_SUBMIT'">{{ text
            }}     (放款失败-点击更新银行卡)</span>
          <span v-else-if="record.pointName === 'SERVICE_PAY_FINISH'">{{ text }}     (还款成功)</span>
          <span v-else>{{ text }}</span>
        </template>
      </a-table>

    </div>
    <RefundTradeModal ref='modalForm' @ok='modalFormOk'></RefundTradeModal>
    <uv-list-modal ref='uvListModal'></uv-list-modal>
  </a-card>
</template>

<script>

import { filterObj } from '@/utils/util'
import { getUvList } from '@/webpublicapi/statistics'
import Dict from '../modules/Dict'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import { getApplist } from '@/api/order'
import uvListModal from '@/views/webpublic/platformOrder/ChartsModal/uvListModal.vue'
import * as echarts from 'echarts'

export default {
  name: 'AppList',
  components: {
    uvListModal,
    RefundTradeModal,
    Dict
  },
  data() {
    return {
      visible: false,
      appList: [],
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      // 查询条件
      queryParam: {
        dataDt: [moment().add('days', -2), moment().add('days', 0)], //默认查看前一天
        appssid: ''
      },
      loading: false,
      // 表头
      columns: [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'curDate'
        },
        {
          title: '点位名',
          align: 'left',
          dataIndex: 'pointName',
          scopedSlots: { customRender: 'pointNameValue' }
        },
        {
          title: 'appssid',
          align: 'left',
          dataIndex: 'appssid'
        },
        {
          title: '统计',
          align: 'left',
          dataIndex: 'value'
        }
      ],
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.loadData(1, 0)

    getApplist().then(res => {
      this.appList = []
      this.appInList = res.data || []
      for (var i = 0; i < this.appInList.length; i++) {
        if (this.appInList[i].appssid != '') {
          this.appList.push(this.appInList[i])
        }
      }
    })
  },
  methods: {
    VisualChart(pagenation) {
      //判断有没有选择产品 //必须选择一个产品
      const appssidValue = this.queryParam.appssid
      console.log('产品类型选了吗', appssidValue)
      if (appssidValue) {
        const paramsechartsarr = this.getQueryParams()
        paramsechartsarr.isPage = pagenation
        console.log('paramsechartsarr参数-->>>', paramsechartsarr)
        //选了产品 发请求 请求有数据才能继续，没数据给出查询出0条数据提示
        getUvList(Object.assign({}, paramsechartsarr)).then((res) => {
          if (res.code === 1000) {
            console.log('res--->', res.data)
            const datalist = res.data.rows
            let uniqueDates = [...new Set(datalist.map(item => item.curDate))]
            console.log('uniqueDates', uniqueDates)
            let numberOfDays = uniqueDates.length
            console.log('要查看几天的数据？', numberOfDays) // 输出结果为3
            if (res.data.rows.length) {
              if (numberOfDays > 3) {
                this.$message.error('当前最多支持查看三天数据！！！')
              } else {
                //有数据且数据不超过三天---处理画图操作
                this.$refs.uvListModal.sendRequest(paramsechartsarr)
                // setTimeout(() => {
                this.$refs.uvListModal.openModal()
                // }, 6000)
                this.$refs.uvListModal.clearEcharts()
              }
            } else {
              this.$message.error('查询到0条数据！！！')
            }
            /*
            * 数据要求，每天的数组根据执行步骤排序
            *
            * */
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.$message.error('请选择产品类型！')
      }


    },
    lookTodays(pagenatihon) {
      console.log('查看当天')
      this.queryParam.dataDt = [moment().add('days', -0), moment().add('days', 0)]
      this.loadData(1, pagenatihon)
    },
    lookThreedays(pagenatihon) {
      console.log('查看三天')
      this.queryParam.dataDt = [moment().add('days', -2), moment().add('days', 0)]
      this.loadData(1, pagenatihon)
    },
    searchQuery(pagenatihon) {
      this.loadData(1, pagenatihon)
    },
    // 重置字典类型搜索框的内容
    searchReset(pagenatihon) {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current, pagenatihon)
      // this.loadData(1, pagenatihon)
    },
    loadData(arg, pagenatihon) {
      // 加载数据 若传入参数1则加载第一页的内容

      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      params.isPage = pagenatihon
      if (params.isPage) {
        delete params.pageNum
        delete params.pageSize
      } else {

      }
      console.log('param-->', params)
      getUvList(Object.assign({}, params)).then((res) => {
        console.log('请求的结果--》', res)
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        curDateStart: dataDt && this.transformTime(dataDt[0]),
        curDateEnd: dataDt && this.transformTime(dataDt[1])
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      console.log('hhhhhhh')
      this.ipagination = pagination
      this.loadData(this.ipagination.current, 0)
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = '新增'
    },

    // model回调
    modalFormOk() {
      console.log('xiixixixi')
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    downLoadData() {
      var params = this.getQueryParams()// 查询条件
      const file = {
        fileUrl: '/api/web/webpublic/statistics/pvuvDataExcel?pointName=' + params.pointName + '&curDateStart=' + params.curDateStart
          + '&curDateEnd=' + params.curDateEnd + '&versionName=' + params.versionName + '&appssid=' + params.appssid + '&type=0',
        fileName: 'pvuvDataExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
